import { render, staticRenderFns } from "./InfoboxTooltip.vue?vue&type=template&id=39f2a513&scoped=true"
import script from "./InfoboxTooltip.vue?vue&type=script&lang=js"
export * from "./InfoboxTooltip.vue?vue&type=script&lang=js"
import style0 from "./InfoboxTooltip.vue?vue&type=style&index=0&id=39f2a513&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f2a513",
  null
  
)

export default component.exports